import { useHits, useInstantSearch } from 'react-instantsearch';

import { Loader } from '@/components/Loader';
import type { WatchHit } from '@/integrations/algolia/types';
import type { WithChildren } from '@/lib/types';

export interface StrapDetailSearchProp extends WithChildren {
  sku: string;
}

export const StrapDetailSearch = ({ children, sku }: StrapDetailSearchProp) => {
  const { hits } = useHits<WatchHit>();
  const strapHit = hits.find((hit) => hit.objectID === sku);
  const { status } = useInstantSearch();

  return (
    <>
      {(status === 'loading' || status === 'stalled') && (
        <Loader data-test-id='StrapDetailLoadingIndicator'></Loader>
      )}
      {strapHit?.plp_preview ? children : <></>}
    </>
  );
};
